

























































































































































  import { Component, Vue, Emit, Inject } from "vue-property-decorator";
  import { namespace } from "vuex-class";
  import { vuex } from "@/store";
  import rest from "@/rest";
  import { signalrEventBus } from "@/main";
  import draggable from "vuedraggable";
  // components
  import EditModuleDlg from "./EditModuleDlg.vue";
  import ModuleImportDlg from "./ModuleImportDlg.vue";
  import DeleteExerciseDlg from "./DeleteExerciseDlg.vue";
  import AiModuleCreatorDlg from "./AiModuleCreatorDlg.vue";
  // interfaces
  import { ExerciseVM } from "@/interfaces/ExerciseVM";
  import { ExType } from "@/interfaces/ExType";
  import { ExTypeItem, exTypeItems } from "@/interfaces/Types";
  import { ParamDictionary } from "@/interfaces/ParamDictionary";
  import { CustomizationVm } from "@/interfaces/CustomizationVm";

  const globals = namespace("globals");
  const customization = namespace("customization");

  @Component({
    components: {
      draggable,
      EditModuleDlg,
      DeleteExerciseDlg,
      AiModuleCreatorDlg,
      ModuleImportDlg
    }
  })
  export default class CourseModules extends Vue {
    @customization.Getter customizationSettings!: CustomizationVm;
    @globals.Getter selectedBundle: any;
    @globals.Getter selectedExercise!: ExerciseVM | null;
    @globals.Getter selectedLanguageCode!: string | null;
    @globals.Getter isMasterLanguageCode!: boolean;
    @globals.Action selectExercise!: (exercise: ExerciseVM | null) => Promise<void>;
    @globals.Action loadModulePages!: () => Promise<void>;
    @globals.Action saveModulePages!: (boolean) => Promise<void>;
    @globals.Action setTranslationRequiredOnBundle!: (boolean) => Promise<void>;

    exerciseZipCreationBusy: Record<number, boolean> = {};
    // Map guid returned from server -> exercise id to clear correct busy flag
    guidToExercise: Record<string, number> = {};
    onAddAllQuestionsBusy = false;
    showEditModuleDlg = false;
    showAiModuleCreatorDlg = false;
    showDeleteExerciseDlg = false;
    showModuleImportDlg = false;
    exercises: ExerciseVM[] = [];
    exTypeItems = exTypeItems;
    guid = "";

    async mounted() {
      this.$root.$on('updateModules:CourseModules', this.updateView);
      this.updateView();
    }

    created() {
      // SignalR event listener
      signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
      signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
    }

    beforeDestroy() {
      this.$root.$off('updateModules:CourseModules', this.updateView);
      // Make sure to cleanup SignalR event handlers when removing the component
      signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
      signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
      // clearAllBodyScrollLocks();
    }

    // SignalR events
    zipArchiveCreationFinished(response: any) {
      // Download will be started by parent view
    }

    async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
      const guid = response.id;
      const exId = this.guidToExercise[guid];
      if (exId === undefined) return;
      console.log("CourseModules > Background task event:", response);
      if (response.status == "INF") {
        vuex.ux.SB_SUCCESS({
          message: response.message,
          timeout: 1500
        });
        return;
      }

      // Completed (SUC) or error (ERR) — clear busy flag for that exercise
      if (response.status == "SUC" || response.status == "ERR") {
        this.$set(this.exerciseZipCreationBusy, exId, false);
        delete this.guidToExercise[guid];
      }
    }

    async onModuleEdited() {
      await this.getExercises(null);
      // await this.loadModulePages(); // Will be done automatically after this.getExercises(null);
    }

    async onFinishedModuleImport(exercise: ExerciseVM) {
      console.log("Module imported: ", exercise);

      this.exercises.push(exercise); // Move exercises to vuex
      await this.selectExercise(exercise);
    }

    async updateView() {
      await this.getExercises(null);
      this.logExercises();
    }

    // List all exercises in console for debugging and show name, index and bundle order
    logExercises() {
      // console.log("Exercises:");
      // this.exercises.forEach((e, i) => {
      //   console.log(`${i}: id=${e.id}, ${e.name} (${e.type}), bundleOrder=${e.bundleOrder}`);
      // });
    }

    get availableModuleTypes(): ExTypeItem[] {
      let moduleTypes = this.exTypeItems;

      if (this.alreadyContains(ExType.Test)) {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.Test);
      }

      if (this.alreadyContains(ExType.ManualApproval)) {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.ManualApproval);
      }

      if (this.alreadyContains(ExType.Signature)) {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.Signature);
      }

      if (this.alreadyContains(ExType.Survey)) {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.Survey);
      }

      if (this.selectedBundle?.sequentialModuleProcessing) {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.ManualApproval && x.value != ExType.ExplanationVideo);
      } else {
        moduleTypes = moduleTypes.filter(x => x.value != ExType.ModuleApproval && x.value != ExType.ExplanationVideo);
      }

      return moduleTypes;
    }

    // function checks if this.exercises already contains a test
    // get alreadyContainsTest(): boolean {
    //   // Convert enum value to its string name with ExType[ExType.Test]
    //   // Example: ExType.Test -> "Test"
    //   return this.exercises.some(exercise => exercise.type === ExType[ExType.Test]);
    // }

    alreadyContains(type: ExType): boolean {
      // Convert enum value to its string name with ExType[ExType.Test]
      // Example: ExType.Test -> "Test"
      return this.exercises.some(exercise => exercise.type === ExType[type]);
    }

    getExerciseIcon(type: string | null): string {
      return exTypeItems.find(i => ExType[i.value] == type)?.icon || "mdi-help-circle-outline";
    }

    // Return translated exercise name
    getTranslatedExerciseName(exercise: ExerciseVM): string {
      if (!exercise) return '';
      const names = (exercise as any).nameTranslations as Record<string,string> | undefined;
      const code = this.selectedLanguageCode || '';
      if (names && code && names[code] && names[code].length > 0) {
        return names[code];
      }
      return exercise.name || '';
    }


    async getExercises(exerciseId: number | null) {
      if (!this.selectedBundle?.id)
        return;

      console.log("CourseModules: load module");
      this.exercises = await rest
        .url("contentManager/getExercises")
        .query({ bundleId: this.selectedBundle.id })
        .get();

      // Workaround: Fix exercise type from Rule to Explanation
      this.exercises.forEach((e) => {
        if (e.type == "Rule") {
          e.type = "Explanation";
          e.isRule = true;
        }
      });

      this.logExercises();

      // Select new

      // Try to reselect previous module
      let id = this.selectedExercise?.id;
      let e = this.exercises.find(e => e.id == id);
      if (e) {
        console.log("CourseModules: select previous module");
        await this.selectExercise(e);
        return;
      }

      // Select default
      if (this.exercises && this.exercises.length > 0) {
        console.log("CourseModules: select first module");
        await this.selectExercise(this.exercises[0]);
      } else {
        console.log("CourseModules: select no module");
        await this.selectExercise(null);
      }
    }

    async onAddExercise(element: ExTypeItem): Promise<void> {
      let exercise: ExerciseVM = {
        id: 0,
        guid: "",
        name: element.value == ExType.ManualApproval ? "Schulung wird freigegeben." : element.value == ExType.ModuleApproval ? "Modul wird freigegeben." : element.label,
        nameTranslations: {},
        image: null,
        exBundleId: this.selectedBundle.id,
        bundleOrder: 0,
        contentPlayer: element.value == ExType.Scorm ? "ScormPlayer" : "QuizPlayer",
        scormSettings: null,
        serviceUri: element.value == ExType.Scorm ? "" : "exercises/getStaticQset",
        enabled: true,
        locked: false,
        unlockedBy: "",
        unlockedByDate: new Date(),
        requiredScoreValue: 0,
        randomizeQuestions: element.value == ExType.Exercise || element.value == ExType.Test,
        randomizeQuestionOptions: element.value == ExType.Exercise || element.value == ExType.Test,
        autoGenerateTest: false, // element.value == ExType.Test ? true : false,
        testAtTheEnd: false,
        questionCnt: element.value == ExType.Exercise ? 10 : element.value == ExType.Test ? 15 : 0,
        type: ExType[element.value],
        isTest: element.value == ExType.Test,
        isRule: element.value == ExType.Rule,
        showResult: false,
        result: 0,
        snooze: false,
        level: 0,
        maxLevel: 0,
        trophyCount: 0,
        maxTrophyCount: 0,
        finished: false,
        hasSignature: false,
        isSigned: false,
        alwaysShowResolution: false,
        showResolutionOnWrongAnswer: true,
        questionFileName: null,
        scormSuspendData: null,
        commentRequired: false,
        commentStructure: ""
      }

      await rest.url("contentManager/addOrUpdateExercise")
        .post(exercise)
        .then(async (response) => {
          if (!response) return;

          console.log("Module added: ", response);

          this.exercises.push(response); // Move exercises to vuex
          await this.selectExercise(response);
          this.logExercises();
        })
        .finally(() => {
          // this.busyOnSave = false;
        });
    }

    async onDragEnd(): Promise<void> {
      await this.updateExerciseOrder();
      this.logExercises();
    }

    async updateExerciseOrder(): Promise<void> {
      this.exercises.forEach((e, i) => {
        e.bundleOrder = i + 1;
      });
      await rest.url("contentManager/setExerciseOrder").post(this.exercises);
    }

    onModuleImport() {
      this.showModuleImportDlg = true;
    }

    // onSelectExercise(exercise: ExerciseVM): void {
    //   this.selectedExercise = exercise;
    // }

    async onExerciseSelected(exercise: ExerciseVM): Promise<void> {
      await this.selectExercise(exercise);
    }

    async onDeleteExercise(exercise: ExerciseVM): Promise<void> {
      await this.selectExercise(exercise);
      this.showDeleteExerciseDlg = true;
    }

    async onExerciseDeleted(): Promise<void> {
      await this.updateExerciseOrder();
      await this.updateView();
      // this.logExercises();
    }

    async onAddAllQuestions(exercise: ExerciseVM): Promise<void> {
      this.onAddAllQuestionsBusy = true;

      await rest.url("contentManager/addAllQuestionsToTest")
        .query({ exerciseId: exercise.id })
        .get()
        .then(async (response) => {
          if (!response) return;
          await this.updateView();
          // await this.setTranslationRequiredOnBundle(true);
        })
        .finally(() => {
          this.onAddAllQuestionsBusy = false;
        });
    }

    async onDownloadExercise(exercise: ExerciseVM): Promise<void> {
      // set busy flag for this exercise
      this.$set(this.exerciseZipCreationBusy, exercise.id, true);

      await this.$l3rnOnlineHub.ensureConnection();

      let params: ParamDictionary = { dictionary: {}};
      params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
      params.dictionary!["ExerciseId"] =  exercise.id.toString();

      await rest.url("contentManager/createModuleZipFile")
        .post(params)
        .then((guid) => {
          this.guid = guid;
          // map the returned guid to the exercise id so we can clear the correct flag on completion
          this.guidToExercise[guid] = exercise.id;
        })
        .catch(() => {
          // on error, clear the busy flag for this exercise
          this.$set(this.exerciseZipCreationBusy, exercise.id, false);
        });
    }

    async onEditExercise(exercise: ExerciseVM): Promise<void> {
      exercise.exBundleId = this.selectedBundle.id;
      await this.saveModulePages(false);
      await this.selectExercise(exercise);
      this.showEditModuleDlg = true;
    }

    async onAiModuleCreate(exercise: ExerciseVM): Promise<void> {
      exercise.exBundleId = this.selectedBundle.id;
      await this.selectExercise(exercise);
      await this.saveModulePages(false);
      this.showAiModuleCreatorDlg = true;
    }

    getExerciseBorderStyle(exercise: ExerciseVM) {
      if (exercise == this.selectedExercise)
        return `border: 2px solid ${this.$store.state.ux.colorAccent};`;
      return "";
    }
  }
